import { connect } from 'react-redux';
import BrandUpload from './BrandUpload';
import { getBrandUploadActionCreator, clearCacheStartActionCreator, clearCacheEndActionCreator } from '../data/actions';
import { getBrandUploadTablesDataSelector, getComputedFiltersSelector } from '../data/selectors';
import { getPageHasOptionLoadedComputedSelector } from '../../../common/components/TopFilter/data/computedSelectors';
import {
    getFiltersThrownError,
    getPageRelatedToFiltersSelector,
    getTopFiltersRawData,
} from '../../../common/data/selectors';
import { getIsGlobalLoadingSelector } from '../../../common/components/Loader/data/selectors';
import { setErrorNotificationDisplayActionCreator } from '../../../errorHandling/data/actions';

const mapStateToProps = state => ({
    data: getBrandUploadTablesDataSelector(state),
    filterSelected: getComputedFiltersSelector(state),
    filtersThrownError: getFiltersThrownError(state),
    hasTopFilterOptionLoaded: getPageHasOptionLoadedComputedSelector(state),
    topFiltersRequestSuccessful: getTopFiltersRawData(state).length > 0,
    filtersFor: getPageRelatedToFiltersSelector(state),
    globalLoading: getIsGlobalLoadingSelector(state),
});

const mapDispatchToProps = {
    getData: getBrandUploadActionCreator,
    startClearCacheLoading: clearCacheStartActionCreator,
    endClearCacheLoading: clearCacheEndActionCreator,
    showErrorNotification: setErrorNotificationDisplayActionCreator,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandUpload);
